import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { ICustomImageWrapper } from "./CustomImageWrapper.tsx.interface";

export const CustomImageWrapper: FC<ICustomImageWrapper> = ({
  children,
  ratio,
  maxHeight = 700,
  classes,
}) => (
  <div
    data-testid="CustomImage_RatioClass"
    className={classNames(
      "ratio",
      "ratio-img",
      `ratio-${ratio}`,
      "h-100",
      classes?.root,
    )}
    style={{
      maxHeight: `${maxHeight}px`,
    }}
  >
    {children}
  </div>
);
